<template>
    <div :class="prefix">
        <div :class="`${prefix}-title`">
            分组
        </div>
        <div :class="`${prefix}-content`">
            <div
                v-if="hasAll"
                :class="[`${prefix}-item`, !filterObj.groupId ? `${prefix}-item--selected` : '']"
                @click="selectGroupFn(0)"
            >
                全部
            </div>
            <div
                v-for="(group,index) in groupArr"
                :key="'group_' + index"
                :class="[`${prefix}-item`, groupVisible[group.id]? `${prefix}-item--active` : '', filterObj.groupId === group.id ? `${prefix}-item--selected` : '']"
                @click="selectGroupFn(group.id)"
            >
                <hc-input
                    v-if="varObj.editGroupId === group.id"
                    ref="edit-group"
                    v-model.trim="apiParamObj.title"
                    placeholder="请输入分组名"
                    size="small"
                    :maxlength="20"
                    clearable
                    @focus="focus"
                    @blur="editGroupFn(group.id)"
                    @keyup.enter.native="editGroupFn(group.id)"
                    @input="(val)=>{ apiParamObj.title = val.replace(groupNameReg,'')}"
                />
                <template v-else>
                    <span class="text">{{ group.title }}</span>
                    <pd-icon v-if="canOperate(group)" class="edit" icon="pencil" @click.stop="handleClick('edit', group)" />
                    <hc-popover
                        v-model="groupVisible[group.id]"
                        placement="bottom-start"
                        width="272px"
                    >
                        <div class="service-group-delete-comfirm">
                            <div class="service-group-delete-comfirm-icon">
                                <i class="hc-icon-warning-outline" />
                            </div>
                            <div class="service-group-delete-comfirm-content">
                                <div class="title">
                                    确定删除分组吗？
                                </div>
                                <div class="des">分组删除后不可恢复，分组内的后端操作也将被删除。</div>
                                <div class="footer">
                                    <hc-button size="mini" @click="showDelete(group)">
                                        取消
                                    </hc-button>
                                    <hc-button size="mini" type="primary" @click="handleClick('delete', group)">
                                        确定
                                    </hc-button>
                                </div>
                            </div>
                        </div>
                        <pd-icon
                            v-if="canOperate(group) && canDelete"
                            slot="reference"
                            icon="trash"
                            :class="['delete', groupVisible[group.id]? 'delete--active' : '']"
                            @click.stop="showDelete(group)"
                        />
                    </hc-popover>
                </template>
            </div>
            <div v-if="varObj.addGroupBool" :class="[`${prefix}-item`]">
                <hc-input
                    ref="addGroupInput"
                    v-model.trim="apiParamObj.title"
                    placeholder="请输入分组名"
                    clearable
                    size="small"
                    :maxlength="20"
                    @blur="addGroupFn"
                    @keyup.enter.native="addGroupFn"
                    @input="(val)=>{ apiParamObj.title = val.replace(groupNameReg,'')}"
                />
            </div>
            <div :class="`${prefix}-content-add`" @click="addGroupDialogFn">
                <i class="hc-icon-plus" />添加分组
            </div>
        </div>
    </div>
</template>

<script>
const groupNameReg = /[^\u4E00-\u9FA5A-Za-z_]/g
export default {
    props: {
        hasAll: {
            type: Boolean,
            default: true,
        },
        isDevEnv: Boolean,
        groupArr: {
            type: Array,
            default: () => [],
        },
        apiParamObj: {
            type: Object,
            default: () => ({}),
        },
        varObj: {
            type: Object,
            default: () => ({}),
        },
        filterObj: {
            type: Object,
            default: () => ({}),
        },
        canDelete: {
            type: Boolean,
            default: true,
        },

    },
    data() {
        return {
            prefix: 'service-group-list',
            groupNameReg,
            showMore: false,
            pageSize: 0,
            rightDisabled: false,
            leftDisabeled: true,
            groupVisible: {},
        }
    },
    computed: {
        isTenantApp() {
            return this.$store.state.modeling.app.isTenant
        },
    },
    
    methods: {
        showDelete(group) {
            if (this.groupVisible[group.id]) {
                this.groupVisible = {}
            } else {
                this.groupVisible = {}
                this.groupVisible[group.id] = true
            }
        },
        canOperate(group) {
            return this.isDevEnv && !group.isSystem && !this.isTenantApp
        },
        updateShowMore() {
            const scrollerWidth = this.getScollerWidth()
            this.showMore = scrollerWidth > 0
        },
        addGroupFn() {
            this.$emit('add-group')
        },
        selectGroupFn(...args) {
            this.$emit('select-group', ...args)
        },
        editGroupFn(...args) {
            this.$emit('edit-group', ...args)
        },
        addGroupDialogFn() {
            this.$emit('add-group-dialog')
            this.$nextTick(() => {
                this.$refs.addGroupInput && this.$refs.addGroupInput.focus()
            })
        },

        handleClick(val, item) {
            this.$emit('handle-click', val, item)
            this.$nextTick(() => {
                if (this.$refs['edit-group'] && this.$refs['edit-group'].length) {
                    this.$refs['edit-group'][0] && this.$refs['edit-group'][0].focus()
                }
            })
        },
        focus(e) {
            e.currentTarget.select()
        },

    },
}
</script>

<style lang="less" scoped>
.service-group-list{
    height: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    &-title {
        padding: 16px;
        padding-bottom: 12px;
        color: #222222;
        font-size: 12px;
        font-weight: 700;
        line-height: 20px;
    }
    &-content {
        padding: 0 12px;
        padding-top: 2px;
        flex: 1;
        overflow-y: auto;
        &::-webkit-scrollbar{
            width: 0px;
        }
        &-add{
            display: flex;
            align-items: center;
            justify-content: center;
            height: 28px;
            border-radius: 3px;
            color: #507AFE;
            font-size: 12px;
            font-weight: 400;
            line-height: 20px;
            cursor: pointer;
            .hc-icon-plus{
                margin-right: 4px;
            }
        }
    }
    &-item{
        display: flex;
        align-items: center;
        height: 30px;
        border-radius: 3px;
        padding: 4px;
        font-size: 13px;
        font-weight: 400;
        line-height: 22px;
        margin-bottom: 4px;
        cursor: default;
        transition: background 0.3s;

        .text {
            flex: 1;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
        }
        .delete {
            margin-left: 4px;
            transform: translateY(1px);
            &--active{
                background: #FFFFFF;
                color: #507AFE !important;
                display: inline-block !important;
            }
        }
        .pd-icon {
            display: none;
            transition: all 0.3s;
            font-size: 16px;
            color: #666666;
            border-radius: 3px;
            transition: background 0.3s;
            cursor: pointer;
            &:hover{
                background: #FFFFFF;
                transition: background 0.3s;
            }
        }
        &--active,&:hover{
            background: #F5F5F5;
            transition: background 0.3s;
            .pd-icon {
                display: inline-block;
                transition: all 0.3s;
            }
        }
        &--selected {
            color: #266EFF;
            background: rgba(38,110,255,0.1)
        }

        /deep/ .hc-input--small{
            height: 30px;
            width: calc(100% + 8px);
            margin: 0 -4px;
            .hc-input__inner{
                height: 30px;
                line-height: 30px;
            }
        }
    }
}
</style>

<style lang="less">
.service-group-delete-comfirm{
    display: flex;
    flex-direction: row;
    width: 240px;
    padding: 4px;
    &-icon{
        .hc-icon-warning-outline{
            font-size: 24px;
            color: #FF9900;
        }
    }
    &-content{
        display: flex;
        flex-direction: column;
        margin-left: 8px;
        flex: 1;
        .title{
            font-size: 14px;
            font-weight: 700;
            line-height: 22px;
            margin-bottom: 17px;
        }
        .des{
            font-size: 12px;
            font-weight: 400;
            color: #666666;
            white-space: pre-wrap;
            margin-bottom: 16px;
        }
        .footer {
            text-align: right;
            button{
                width: 56px;
                height: 24px;
                font-size: 12px;
                font-weight: 400;
                padding: 4px 8px;
            }
        }
        
    }
}
</style>>
